/**
 * Persist Smoke Drive mobile browse preferences (session).
 */

const STORAGE_KEY = 'lsc.operatorDrive.mobile.v1';

export const OPERATOR_DRIVE_MOBILE_VIEWS = Object.freeze(['list', 'grid', 'compact']);

/**
 * @returns {{ viewMode: 'list'|'grid'|'compact' }}
 */
export function readOperatorDriveMobilePrefs() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return { viewMode: 'list' };
        const parsed = JSON.parse(raw);
        const viewMode = OPERATOR_DRIVE_MOBILE_VIEWS.includes(parsed?.viewMode)
            ? parsed.viewMode
            : 'list';
        return { viewMode };
    } catch {
        return { viewMode: 'list' };
    }
}

/**
 * @param {{ viewMode?: 'list'|'grid'|'compact' }} patch
 */
export function writeOperatorDriveMobilePrefs(patch) {
    try {
        const cur = readOperatorDriveMobilePrefs();
        const viewMode = OPERATOR_DRIVE_MOBILE_VIEWS.includes(patch?.viewMode)
            ? patch.viewMode
            : cur.viewMode;
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ viewMode }));
    } catch {
        /* ignore */
    }
}
